import { render } from "./CatalogBreadcrumbs.vue?vue&type=template&id=583512fb"
import script from "./CatalogBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./CatalogBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__